<template>
  <div class="main-wrapper">
    <UserProfile />
    <UserDataInfo />
    <NavList />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Toast, Dialog, Loading } from "vant";
import UserProfile from "@/components/setting/UserProfile.vue";
import NavList from "@/components/setting/NavList.vue";
import UserDataInfo from "@/components/setting/UserDataInfo.vue";

export default {
  components: {
    Loading,
    UserProfile,
    UserDataInfo,
    NavList,
  },
  data() {
    return {
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push("/auth/login");
      return;
    }
  },
};
</script>

<style scoped></style>
